import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "username",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300",
  name: "username"
}, null, -1)
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "flex flex-row gap-1 md:gap-2" }

import { ref } from "vue";
import gamePlayer from "@/components/gamePlayer.vue";
import gameRounds from "./components/gameRounds.vue";
import { useStore } from "@/stores/game";
import { useWindowSize } from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const playerName = ref();
const addPlayer = () => {
  store.addPlayer(playerName.value);
  playerName.value = "";
};

function submit () {
  addPlayer()
}

const { width, height } = useWindowSize()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "container p-2",
    style: _normalizeStyle({'height': (_unref(height)-10) + 'px'})
  }, [
    _createElementVNode("form", {
      name: "player",
      onSubmit: _withModifiers(submit, ["prevent"]),
      autocomplete: "off"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            placeholder: "Typ naam + ENTER om een speler toe te voegen",
            "data-lpignore": "true",
            type: "text",
            id: "username",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((playerName).value = $event)),
            class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          }, null, 512), [
            [_vModelText, playerName.value]
          ]),
          (playerName.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                id: "reset",
                onClick: submit,
                type: "submit",
                class: "text-white absolute bg-green hover:bg-blue focus:ring-4 focus:outline-none focus:ring-grey-300 font-medium rounded-lg text-sm px-4 py-2"
              }, "Toevoegen"))
            : _createCommentVNode("", true)
        ])
      ])
    ], 40, _hoisted_1),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(gameRounds, { class: "flex-none w-16" }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).players, (player, index) => {
        return (_openBlock(), _createBlock(gamePlayer, {
          key: index,
          playerIndex: index,
          player: player
        }, null, 8, ["playerIndex", "player"]))
      }), 128))
    ])
  ], 4))
}
}

})